import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import handleFloating from "../../HOCs/handleFloating";
import styles from "./ageVerificationModal.scss";
import { LocalStorageKey, PageRoute } from "../../models";
import history from "../../history";
import confirmModal from "../../services/confirmModal";
import { localStorage } from "../../services";
import { useLocation } from "react-router-dom";
import { setAgeVerified } from "../../routes/Ad/ad.ducks";

export interface AgeVerificationModalProps {
  onOk?: () => void;
  onCancel?: () => void;
}

function AgeVerificationModal(props: AgeVerificationModalProps) {
  const { onOk, onCancel } = props;
  const location = useLocation();
  const dispatch = useDispatch();

  const handleBack = () => {
    
    // Check if there is in-app navigation history
    if (location.key && location.key !== "default") {
      history.goBack();
      return;
    }

    // On initial load, check if referrer is from the same origin
    if (document.referrer) {
      try {
        const refUrl = new URL(document.referrer);
        if (refUrl.origin === window.location.origin) {
          window.location.href = document.referrer;
          return;
        }
      } catch (e) {
        // Ignore parsing errors, fallback to homepage
      }
    }

    // Fallback: go to homepage
    history.push(PageRoute.home);
  };

  useEffect(() => {
    confirmModal.show({
      okText: "Da, imam 18 ili više godina",
      cancelText: "Ne, nemam 18 godina",
      onOk: () => {
        localStorage.setItem(LocalStorageKey.isAgeVerified, true);
        dispatch(setAgeVerified(true));
        onOk ? onOk() : window.location.reload();
      },
      onCancel: () => {
        localStorage.setItem(LocalStorageKey.isAgeVerified, false);
        dispatch(setAgeVerified(false));
        onCancel ? onCancel() : handleBack();
      },
      maskClosable: false,
      children: (
        <div className={styles.modalContent}>
          <h2>Pristup dozvoljen samo osobama starijim od 18 godina</h2>
          <p>Molimo vas da potvrdite svoju dob kako biste nastavili.</p>
        </div>
      ),
      centered: true,
      mask: true,
      
    });
  }, []);

  return null;
}

AgeVerificationModal.defaultProps = {
};

export default handleFloating(AgeVerificationModal);



// WEBPACK FOOTER //
// ./src/components/AgeVerificationModal/index.tsx